import PostSerializer from '@linc-technologies/linced-common/serializers/posts/post';

export default class Post extends PostSerializer {
  normalize(model, hash) {
    hash.raw_assessment_id = hash.assessmentId;
    return super.normalize(...arguments);
  }
}
